import React from 'react';
import styled from 'styled-components';
import { flatten } from 'lodash';
import Warning from './IncidentWarning';
import { formatTimeOnly } from '../../utils/time';
import { worstLevelBackground } from '../../utils/colors';

const StyledIncidentContainer = styled.div`
  color: #fff;
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 20px;
`;

const StyledIncidentWarning = styled.div`
  margin-top: 10px;
`;

const StyledAvailabilityRequirement = styled.span`
  background: black;
  color: white;
  font-weight: 600;
  padding: 4px;
  border-radius: 5px;
  margin: 0 3px;
`;

const IncidentContainerTitle = styled.div`
  font-size: 24px;
  margin-bottom: 5px;
`;

const intersects = (a, b) => a && b && a.some(x => b.includes(x));

const IncidentWarning = ({ warningStatus, skills, groups }) => {
  // Show warnings if they apply to one of the tasks of the groups,
  // or apply to the group itself or its descendants
  const applicableTaskIds = flatten(groups.map(g => g.tasks.map(t => t.id)));
  const tasksIntersect = intersects(applicableTaskIds, warningStatus.availability_requirement.task_ids);

  const groupIds = [...groups.map(g => g.id), ...groups.flatMap(g => g.descendant_ids)];
  const groupsIntersect = intersects(groupIds, warningStatus.availability_requirement.group_ids);

  if (!tasksIntersect && !groupsIntersect) return null;

  return (
    <StyledIncidentWarning>
      <StyledAvailabilityRequirement>{warningStatus.availability_requirement.name}</StyledAvailabilityRequirement>
      <Warning warningStatus={warningStatus} skills={skills} />
    </StyledIncidentWarning>
  );
};

// renders a wrapper around an incident, and contains the
// incident warnings
export const IncidentContainer = ({ incident, groups, skills, hideHeader, showAllStatuses }) => {
  let warningStatuses = incident.warning_statuses;
  if (!showAllStatuses) {
    warningStatuses = warningStatuses.filter(ws => ws.warning_level === 'below_required');
  }

  if (warningStatuses.length === 0) return null;

  // find the color that matches the worst appliance status
  const warningLevels = warningStatuses.map(ws => ws.warning_level);
  const backgroundColor = worstLevelBackground(warningLevels);

  return (
    <StyledIncidentContainer style={{ background: backgroundColor }}>
      {!hideHeader && (
        <IncidentContainerTitle>
          <small>{formatTimeOnly(incident.created_at)}</small> {incident.body}
        </IncidentContainerTitle>
      )}
      {incident.stations.map(station => (
        <StyledAvailabilityRequirement key={station.id}>{station.name}</StyledAvailabilityRequirement>
      ))}
      {warningStatuses.map((ws, index) => (
        <IncidentWarning key={index} warningStatus={ws} groups={groups} skills={skills} />
      ))}
    </StyledIncidentContainer>
  );
};
